import moment from "moment";

const formatTime = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "number" || /^\d+$/.test(String(value))) {
    const n = Number(value);
    return moment.unix(n < 1e12 ? n : Math.floor(n / 1000)).format(
      "YYYY-MM-DD HH:mm:ss",
    );
  }
  return moment(value).isValid()
    ? moment(value).format("YYYY-MM-DD HH:mm:ss")
    : String(value);
};

const escapeCsvValue = (value) => {
  if (value == null) return "";
  const str = String(value);
  if (str.includes(",") || str.includes('"') || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const convertPaymentsToCSV = (responseData, { includePaidTo = false } = {}) => {
  if (!responseData) {
    throw new Error("Payment data is null or undefined");
  }
  const dataArray = responseData.data || responseData;
  if (!Array.isArray(dataArray)) {
    throw new Error("Expected data to be an array");
  }
  if (dataArray.length === 0) {
    throw new Error("No Data Found");
  }

  const headers = [
    "No",
    "Payment Time",
    ...(includePaidTo ? ["Paid To"] : []),
    "OEM",
    "Dealer",
    "Amount",
    "Payment Mode",
    "Card",
    "Status",
    "Transaction ID",
  ];

  const rows = dataArray.map((payment) => [
    payment.PaymentNo ?? "",
    formatTime(payment.PaymentTime),
    ...(includePaidTo
      ? [payment.PaidTo ?? payment.PaidToName ?? ""]
      : []),
    payment.OemName ?? "",
    payment.DealerName ?? payment.DealerNo ?? "",
    payment.Amount ?? "",
    payment.PaymentMode ?? "",
    payment.CardLast4 ? `****${payment.CardLast4}` : "",
    payment.PaymentStatus ?? "",
    payment.TransactionID ?? "",
  ]);

  return [headers, ...rows]
    .map((row) => row.map(escapeCsvValue).join(","))
    .join("\n");
};

export const downloadPaymentCSV = (
  paymentData,
  filename = "payment_export.csv",
  options = {},
) => {
  const csvContent = convertPaymentsToCSV(paymentData, options);
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
